
"use strict";

export default periodsUrl => sb => {
    let periods;
    let yearSelect;
    let monthSelect;

    const fetchPeriods = function fetchPeriods() {
        if (periods !== void 0) {
            return Promise.resolve(periods);
        }

        return sb.postApi(periodsUrl).then(
            date => {
                let groupedData = {};
                let valuesObj = {};

                for (let i = 0; i< date.years.length; i++) {
                    let key = date.years[i].year;
                    let value = date.years[i].months;
                    valuesObj = {};

                    for (let j =0; j < value.length; j++) {
                        valuesObj[value[j]] = 'Month' + value[j];
                    }
                    groupedData[key] = valuesObj;
                }


                return groupedData ? groupedData : {};
            }
        );
    };

    const populatePeriodsSelects = function populatePeriodsSelects(
        yearSelection,
        monthSelection
    ) {
        return fetchPeriods().then(pds => {
            let selectedYear = yearSelection,
                selectedMonth = monthSelection;

            /* If the user has selected a year that isn't this year, select Jan
            for the month, otherwise it will default to the latest month. */
            if (selectedYear && !selectedMonth) {
                if (parseInt(selectedYear, 10) !== (new Date()).getUTCFullYear()) {
                    selectedMonth = 1;
                }
            }

            // Years (in reverse order)
            sb.empty("#period_year")
                .append("#period_year", Object.keys(pds).reverse().map(
                    year => {
                        selectedYear = selectedYear || year;
                        let selected = year === selectedYear ? " selected" : "";
                        return `<option${selected} value="${year}">${year}</option>`;
                    }
                ).join("\n"));

            // Months: reverse to select the most recent month
            const monthOptions = Object.keys(pds[selectedYear]).reverse().map(
                month => {
                    if (selectedMonth === void 0) {
                        selectedMonth = selectedMonth || month;
                    }
                    let selected = selectedMonth === month ? " selected" : "";

                    const date = new Date(2015, month - 1, 1);
                    const fmt = new Intl.DateTimeFormat("en-GB", {month: "long"});

                    const monthName = fmt.format(date);

                    return `<option${selected} value="${month}">${monthName}</option>`;
                }
            );
            // Reverse again so they're displayed chronologically
            sb.empty("#period_month").append(
                "#period_month",
                monthOptions.reverse().join("\n")
            );
        });
    };

    const onYearChange = function onYearChange() {
        populatePeriodsSelects(yearSelect[0].value);
    };

    const onMonthChange = function onMonthChange() {
        populatePeriodsSelects(yearSelect[0].value, monthSelect[0].value);
    };

    return {
        init() {
            yearSelect = sb.find("#period_year");
            monthSelect = sb.find("#period_month");

            populatePeriodsSelects();

            sb.addEvent(yearSelect, "change", onYearChange);
            sb.addEvent(monthSelect, "change", onMonthChange);
        },
        destroy() {
            sb.removeEvent(monthSelect, "change", onMonthChange);
            sb.removeEvent(yearSelect, "change", onYearChange);

            periods = null;

            yearSelect = null;
            monthSelect = null;
        }
    }
}
